import { createGA4Event as createSharedGA4Event } from '../../../shared/modules/spGa4';

// Kitman cart mutations navigate instead of refreshing the current document.
// Keep shared purchase/view/checkout handling, but report cart changes from the server result.
// eslint-disable-next-line import/prefer-default-export
export const createGA4Event = (pushToDataLayer) => {
  const shared = createSharedGA4Event(pushToDataLayer);
  const handler = (e) => {
    const target = e?.delegateTarget || e?.target;
    if (['add_to_cart', 'remove_from_cart'].includes(target?.dataset?.ga4Event)) return;
    shared(e);
  };
  handler.reportBasketResult = (data) => {
    const ecommerce = data?.ecommerce;
    if (!['add_to_cart', 'remove_from_cart'].includes(data?.event)
      || !/^[A-Z]{3}$/.test(ecommerce?.currency) || !Number.isFinite(ecommerce?.value)
      || ecommerce.value < 0 || !Array.isArray(ecommerce.items) || !ecommerce.items.length
      || !ecommerce.items.every((item) => item && (item.item_id || item.item_name)
        && Number.isFinite(item.price) && item.price >= 0
        && Number.isFinite(item.quantity) && item.quantity > 0)) return Promise.resolve();
    return new Promise((resolve) => {
      // Give GTM time before navigation, but never trap checkout when GTM is blocked.
      const timeout = setTimeout(resolve, 800);
      try {
        pushToDataLayer({
          event: data.event,
          ecommerce,
          eventCallback: () => { clearTimeout(timeout); resolve(); },
          eventTimeout: 800,
        });
      } catch (error) {
        clearTimeout(timeout);
        resolve();
      }
    });
  };
  return handler;
};
